var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shoptit"},[_c('div',{staticClass:"tit"},[_vm._v("\n      "+_vm._s(_vm.tit.name)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"tit_english"},[_vm._v("\n      "+_vm._s(_vm.tit.english)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60c9634c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/shop/components/shoptit.vue
// module id = null
// module chunks = 